export default "__VITE_ASSET__82f4bd99__"